import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99619e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-icon btn-primary",
  id: "btnSearchSubmit",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas px-1" }, "search")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createBlock(_component_dp_form, {
    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('submit'))),
    as: "form",
    novalidate: "",
    class: "input-group"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        class: "form-control",
        placeholder: `${_ctx.$t('searchTrademark')}...`,
        name: "searchTrademark"
      }, null, 8, _hoisted_1), [
        [_vModelText, _ctx.searchQuery]
      ]),
      (_ctx.hasSearchQuery)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-close position-absolute h-100",
            id: "btnSearchReset",
            type: "reset",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
          }))
        : _createCommentVNode("", true),
      _hoisted_2
    ]),
    _: 1
  }))
}